'use client'

import useUser from 'shared/hooks/use-user'
import { formatExactDateTime } from 'shared/utils/date-time-format'

interface DateTimeProps {
  time: string
  className?: string
}

function DateTime({ time, className }: DateTimeProps) {
  const { intlLocale, user } = useUser()

  if (!user || Number.isNaN(new Date(time).getTime())) return null

  return (
    <time dateTime={time} className={className}>
      {formatExactDateTime(time, { intlLocale, timeZone: user.timezone })}
    </time>
  )
}

export { DateTime }
export type { DateTimeProps }
